import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Lesson } from '../../../models/lesson'
import { MenuPopoverComponent } from '../../../components/menu-popover/menu-popover.component'
import { Router } from '@angular/router'
import { PopoverController } from '@ionic/angular'
import { TeacherProvider } from '../../../providers/teacher/teacher.provider'
import { Course } from '../../../models/course'
import { Teacher } from '../../../models/teacher'
import { CourseCssService } from '../course-css.service'
import { instanceToInstance } from 'class-transformer'
import { MessagePopoverComponent, MessagePopoverButton } from 'src/app/components/message-popover/message-popover.component';
import { MoveCopyLessonComponent } from 'src/app/components/move-copy-lesson/move-copy-lesson.component';
import { Common } from 'src/app/lib/common';
import { Resources } from 'src/app/models/resources';

@Component({
  selector: 'app-lesson-tile',
  templateUrl: './lesson-tile.component.html',
  styleUrls: ['./lesson-tile.component.scss']
})
export class LessonTileComponent implements OnInit {

  @Input() lesson: Lesson
  @Input() course: Course

  _teacher: Teacher = Teacher.defaults()
  get teacher(): Teacher { return this._teacher }
  @Input() set teacher(teacher: Teacher) { this._teacher = teacher ||  Teacher.defaults() }

  @Input() isEditing: boolean

  _resources: Resources = Resources.defaults()
  get resources(): Resources {
    return this._resources
  }

  @Input() set resources(resources: Resources) {
    this._resources = resources || Resources.defaults()
  }

  isRenaming: boolean = false;
  isDescriptionEdit: boolean = false;
  isChangingNumSongs: boolean = false
  @Input() isDragging: boolean = false;
  constructor(
    private router: Router,
    private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider,
    private courseCssService: CourseCssService) { }

  ngOnInit() {
  }

  lessonClasses(): string[] {
    const classes = ['lesson-tile', 'existing', this.courseCssService.responsiveClass()]
    if (this.isEditing) {
      classes.push('editing')
    }
    return classes
  }

  lessonChanged() {
    this.lesson.isDirty = true
    this.course.isDirty = true
  }

  chooseLessonEdit(event) {

    let changeNumActivitiesName = 'Change # of Activities'
    if (this.course.classType == Course.ClassType.RhythmKids) {
      changeNumActivitiesName = 'Change RK Level'
    }
    const lessionDescriptionLabel: string = this.lesson.description ? "Edit Description" : "Add Description"
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
      { name: 'Rename', action: () => { this.toggleRenameLesson() }},
      { name: changeNumActivitiesName, action: () => { this.toggleChangeNumLessons() }},
      // { name: lessionDescriptionLabel, action: () => { this.toggleLessonDescription() }},
      // { name: 'Change # of Activities', action: () => { this.toggleChangeNumLessons() }},
      { name: 'Duplicate', action: () => { this.duplicateLesson() }},
      { name: 'Delete', action: () => { this.deleteLesson() }},
      { name: 'Move/Copy to Another Semester', action: () => { this.moveCopyLessonPopover()}}
    ], 280)
  }

  moveCopyLessonPopover(){
    this.popoverCtrl.create({
      component: MoveCopyLessonComponent,
      cssClass: 'lesson-plans-popover',
      componentProps:  { 
        teacher: this.teacher, 
        resources: this.resources, 
        lesson: this.lesson, 
        course: this.course 
      }
    }).then(popover => {
      popover.present().then(() => Common.ensurePopoverOnScreen())
    })
  }

  cancel() {
    this.isRenaming = false;
    this.isChangingNumSongs = false;
    this.isDescriptionEdit = false;
  }

  toggleRenameLesson() {
    this.isRenaming = !this.isRenaming
    this.isDescriptionEdit = false;
  }

  toggleLessonDescription() {
    this.isDescriptionEdit = !this.isDescriptionEdit;
    this.isRenaming = false;
  }

  toggleChangeNumLessons() {
    this.isChangingNumSongs = !this.isChangingNumSongs
  }

  chooseNumberOfLessons(event) {

    if (this.course.classType == Course.ClassType.RhythmKids) {
      this.chooseNumberOfLessonsForRhythmKids(event)
      return
    }

    const numberOfLessons = this.course.getLessonCounts
    if (!numberOfLessons.includes(this.lesson.numSongs)) {
      numberOfLessons.push(this.lesson.numSongs)
    }

    if (numberOfLessons.length > 0) {
      MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, numberOfLessons.map(cnt => {
        return {name: cnt + ' Activities', action: () => {
          this.lesson.numSongs = cnt
          this.teacherProvider.adjustNumSongs(this.lesson, null)
        }}
      }))
    }
  }

  chooseNumberOfLessonsForRhythmKids(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
      {
        name: 'RK Level 1',
        action: () => {
          this.lesson.numSongs = 9
          if (this.lesson.classType != Course.ClassType.RhythmKidsLevel1) {
            this.lesson.classType = Course.ClassType.RhythmKidsLevel1
            this.lesson.isDirty = true            
          }
        }
      },
      {
        name: 'RK Level 2',
        action: () => {
          this.lesson.numSongs = 9
          if (this.lesson.classType != Course.ClassType.RhythmKidsLevel2) {
            this.lesson.classType = Course.ClassType.RhythmKidsLevel2
            this.lesson.isDirty = true            
          }
        }
      }
    ])
  }

  getLessonNumSongsText(): string {
    // if (this.lesson.uuid == 'c43527bf-5b38-4107-a3ff-e0ab4755c530') {
    //   console.log('getting text')
    //   console.log(this.lesson.classType)      
    // }

    if (this.lesson.classType == Course.ClassType.RhythmKidsLevel1) {
      return 'RK Level 1'
    }
    if (this.lesson.classType == Course.ClassType.RhythmKidsLevel2) {
      return 'RK Level 2'
    }
    if (this.course.classType == Course.ClassType.RhythmKids) {
      return 'Rhythm Kids'
    }
    return `${this.lesson.numSongs} Activities`
  }

  saveLesson() {
    const course = instanceToInstance(this.course)
    const lesson = instanceToInstance(this.lesson)
    this.teacherProvider.updateLesson(course, lesson)
    this.teacherProvider.saveTeacher()
    this.isRenaming = false;
    this.isChangingNumSongs = false;
    this.isDescriptionEdit = false;
  }

  duplicateLesson() {
    const lesson = this.lesson.unsavedCopy()
    lesson.name = this.course.uniqueLessonName(lesson.name)
    this.teacherProvider.addLesson(this.course, lesson)
  }

  deleteLesson() {
    MessagePopoverComponent.present(this.popoverCtrl, 'Delete Lesson Plan?', 'Are you sure you want to delete this lesson plan from the semester?', false, false, [
      { name: 'Cancel', type: MessagePopoverButton.Type.Cancel },
      { name: 'Delete', type: MessagePopoverButton.Type.Submit, action: () => {
        this.course.lessons = this.course.lessons.map((ls: Lesson) => {
          if (ls.uuid === this.lesson.uuid) {
            ls.isDirty = true
            ls.isDeleted = true
          }
          return ls
        })
        const course = instanceToInstance(this.course)
        const lesson = instanceToInstance(this.lesson)
        this.teacherProvider.updateCourse(course)
        this.teacherProvider.deleteLesson(course, lesson)
        this.teacherProvider.saveTeacher()
      }}
    ])
  }

  gotoLesson() {
    if (this.isRenaming || this.isChangingNumSongs || this.isEditing || this.isDescriptionEdit) {
      return
    }
    this.router.navigate(['lesson', this.course.uuid, this.lesson.uuid])
  }
}
